import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'
import Switch from '@mui/material/Switch';

export default function WaypointRender(props) {
    const { setNodeData, nodeData } = props;
    const [waypoints, ] = useState(["waypoint1", "waypoint2", "waypoint3"]);
    const [check_reached, setToggle] = useState(nodeData && nodeData.type === "waypoint"? nodeData.check_reached: true);
    const [selected_waypoint, setSelectedWaypoint] = useState(nodeData && nodeData.type==="waypoint"? nodeData.selectedWaypoint: waypoints[0])

    setNodeData({
      type: "waypoint",
      selectedWaypoint: selected_waypoint,
      check_reached: check_reached
    })

    const handleChange = (event) => {
      setSelectedWaypoint(event.target.value)
      setNodeData({
        type: "waypoint",
        selectedWaypoint: event.target.value,
        check_reached: check_reached
      })
    }

    const handleChangeCheckReached = (event) => {
      setToggle(event.target.checked)
      console.log(event.target.checked)
      setNodeData({
        type: "waypoint",
        selectedWaypoint: selected_waypoint,
        check_reached: event.target.checked
      })
    }

    return(
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextField
        select
        id="outlined-required"
        label="Waypoint"
        defaultValue={selected_waypoint}
        value={selected_waypoint}
        name="robot_actions"
        style={{width: "100%"}}
        onChange={handleChange}
      >
      {waypoints.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{display: "flex", alignItems:'center', justifyContent:"center", flexDirection: "row"}}>
        <Typography>Async</Typography>
        <Switch onChange={handleChangeCheckReached} checked={check_reached}></Switch>
        <Typography>Sync</Typography>
      </Grid>
      </Grid>)
}